import { ref, reactive } from "vue";
import {
  getApplicationFullItem,
  updateApplication as updateApplicationApi,
  updateApplicationStatus as updateApplicationStatusApi,
} from "../api";

const PUT_FIELDS = [
  "content",
  "content_kz",
  "content_en",
  "contract_amount",
  "languages",
  "state_duty",
  "status",
  "note",
  "description",
  "multiple_languages",
  "locality",
  "relatives",
  "exec_inscription_type",
  "fields",
];

function pickPutFields(source) {
  const out = {};
  PUT_FIELDS.forEach((key) => {
    if (source[key] !== undefined) {
      out[key] = source[key];
    }
  });
  return out;
}

export function useApplicationEditor(uuid) {
  const form = reactive({
    id: null,
    uuid: null,
    number: null,
    status: null,
    description: "",
    note: "",
    content: null,
    content_kz: null,
    content_en: null,
    languages: ["ru"],
    contract_amount: null,
    state_duty: null,
    price: null,
    template_code: null,
    notary_uuid: null,
    notary_identifier: null,
    participants_fio: [],
    exec_inscription_type: null,
  });
  const loading = ref(false);

  async function fetchApplication(id, { silent = false } = {}) {
    if (!silent) loading.value = true;
    try {
      const data = await getApplicationFullItem(id ?? uuid?.value);
      if (data?.payload) {
        Object.assign(form, data.payload);
      } else if (data && !data.success) {
        Object.assign(form, data);
      } else if (data && data.id) {
        Object.assign(form, data);
      }
      return data;
    } catch (e) {
      console.error("fetchApplication error:", e);
    } finally {
      if (!silent) loading.value = false;
    }
  }

  async function updateApplication(payload) {
    const txId = uuid?.value || form.id;
    if (!txId) return null;
    const body = payload ? pickPutFields(payload) : pickPutFields(form);
    return await updateApplicationApi(txId, body);
  }

  async function changeStatus(status, note = "") {
    const txId = uuid?.value || form.id;
    if (!txId) return null;
    const data = await updateApplicationStatusApi(txId, { status, note });
    if (data?.ok) {
      form.status = status;
    }
    return data;
  }

  return {
    form,
    loading,
    fetchApplication,
    updateApplication,
    changeStatus,
  };
}
